class DeliveryTime extends HTMLElement {
    constructor() {
        super(), this.formatString = this.getAttribute("data-frm-day"), this.excludedDaysFrom = this.getAttribute("data-exclude-day-from"), this.excludedDays = this.getAttribute("data-exclude-day").replace(/ /g, "").split(","), this.numbDateStart = this.getAttribute("data-estimate-start"), this.numbDateEnd = this.getAttribute("data-estimate-end"), this.targetTime = this.getAttribute("data-time"), this.targetTimeFm = this.targetTime.replace(/ /g, "").replace(/:/g, ""), this.hr = this.querySelector(".productView-dlvr__remaining-hr"), this.mins = this.querySelector(".productView-dlvr__remaining-mins"), this.nowT = new Date;
        this.nowT.getHours().toString().padStart(2, "0"), this.nowT.getMinutes().toString().padStart(2, "0"), this.nowT.getSeconds().toString().padStart(2, "0");
        if (this.checkExclude = this.checkAllExcludeDays(this.excludedDays), this.checkExclude) return;
        this.productDeliveryTime();
        const t = this.countdownToTime(this.targetTime);
        this.hr.innerHTML = t.hours, this.mins.innerHTML = t.minutes, this.style.display = "block", setInterval((() => {
            const t = this.countdownToTime(this.targetTime);
            this.hr.innerHTML = t.hours, this.mins.innerHTML = t.minutes
        }), 1e3)
    }
    checkAllExcludeDays(t) {
        const e = new Date,
            i = new Date(e);
        for (let e of t) {
            const t = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].indexOf(e);
            if (i.getDay() === t) return !0
        }
        return !1
    }
    productDeliveryTime() {
        const t = $("[data-delivery-time]");
        if (0 == t.length) return;
        let e = this.excludeDays(this.excludedDays, this.numbDateStart),
            i = this.excludeDays(this.excludedDays, this.numbDateEnd);
        e instanceof Date || (e = new Date(e)), i instanceof Date || (i = new Date(i));
        const a = this.nowT.getHours().toString().padStart(2, "0"),
            s = this.nowT.getMinutes().toString().padStart(2, "0"),
            r = this.nowT.getSeconds().toString().padStart(2, "0");
        parseInt(a + s + r) >= parseInt(this.targetTimeFm) && (e.setDate(e.getDate() + 1), i.setDate(i.getDate() + 1));
      const monthNames = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

let formattedRange = '';
if (e.getMonth() === i.getMonth()) {
    formattedRange = `${monthNames[e.getMonth()]} ${e.getDate()} – ${i.getDate()}`;
} else {
    formattedRange = `${monthNames[e.getMonth()]} ${e.getDate()} – ${monthNames[i.getMonth()]} ${i.getDate()}`;
}

t.find("[data-start-delivery]").html(formattedRange);
//t.find("[data-end-delivery]").html(''); // optional: clear end
    }
    formatDate(t, e) {
        const i = new Date(t),
            a = i.toLocaleDateString("en-US", {
                weekday: "long"
            }),
            s = i.toLocaleDateString("en-US", {
                day: "2-digit"
            }),
            r = i.toLocaleDateString("en-US", {
                month: "long"
            }),
            n = (i.getMonth() + 1).toString().padStart(2, "0"),
            o = i.toLocaleDateString("en-US", {
                year: "numeric"
            });
        return e.replace("d", a).replace("DD", s).replace("MMM", r).replace("MM", n).replace("YYYY", o)
    }
    excludeDays(t, e) {
        const i = new Date,
            a = new Date(i);
        if ("only_delivery" == this.excludedDaysFrom) a.setDate(a.getDate() + parseInt(e)), t.forEach((t => {
            const e = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].indexOf(t);
            a.getDay() === e && a.setDate(a.getDate() + 1)
        }));
        else {
            let i = parseInt(e);
            for (; i > 0;) a.setDate(a.getDate() + 1), this.isExcludedDayOfWeek(a, t) || i--
        }
        return a.toLocaleDateString("en-US")
    }
    isExcludedDayOfWeek(t, e) {
        const i = t.getDay();
        return e.includes(["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"][i])
    }
    countdownToTime(t) {
        const e = new Date,
            i = `${e.toDateString()} ${t}`,
            a = new Date(i);
        a < e && a.setDate(a.getDate() + 1);
        const s = a - e;
        return {
            hours: Math.floor(s / 36e5),
            minutes: Math.floor(s % 36e5 / 6e4)
        }
    }
}
customElements.define("delivery-time", DeliveryTime);